<template>
  <v-sheet class="bg-background flex-1-1 px-4" max-width="800">
    <v-form ref="resetPasswordForm" v-model="isFormValid" @submit.prevent>
      <v-sheet class="border-opacity-25 border-thin rounded-lg overflow-hidden pa-5">
        <v-text-field
          v-model="emailTemplate.subject"
          label="Subject"
          :rules="[rules.required]"></v-text-field>
        <v-text-field
          v-model="emailTemplate.from"
          label="From Address"
          :rules="[rules.required, rules.email]"></v-text-field>
        HTML Body
        <Editor
          v-model="emailTemplate.htmlBody"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>

        <v-textarea
          v-model="emailTemplate.textBody"
          label="Text Body"
          :rules="[rules.required]"></v-textarea>
      </v-sheet>

      <br />
      <v-btn
        color="primary"
        block
        class="rounded-lg mb-8"
        elevation="2"
        :disabled="!isFormValid"
        @click="saveEmailTemplate"
        >Save Email Template</v-btn
      >
    </v-form>
  </v-sheet>
</template>
<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { rules } from '@/helpers';
import Editor from '@tinymce/tinymce-vue';
import { useEmailTemplateStore } from '@/stores/modules/admin';
import { EmailTemplateDTO, IEmailTemplateDTO } from '@/dtos/email.template.dto';
import { SNACKSTATUS } from '@/stores/util';
import { useUpdateStatusStore } from '@/stores/modules';
const emit = defineEmits(['snack']);
import '@/components/tinymce/tinymce';
const route = useRoute();
const emailTemplateId = ref(
  Array.isArray(route.params.emailTemplateId)
    ? route.params.emailTemplateId[0]
    : (route.params.emailTemplateId ?? ''),
);
const emailTemplateStore = useEmailTemplateStore();
const statusStore = useUpdateStatusStore();
const emailTemplate = ref<IEmailTemplateDTO>(new EmailTemplateDTO());
const isFormValid = ref<boolean>(false);

watch(
  () => statusStore.getStatus(`email-template-${emailTemplateId.value}`),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    const key = `email-template-${emailTemplateId.value}`;
    emit('snack', 'Email Template', value, statusStore.getError(key));
  },
);

watch(emailTemplateStore.getEmailTemplateByIdQuery, () => {
  emailTemplate.value = new EmailTemplateDTO(emailTemplateStore.getEmailTemplateByIdQuery.data);
});

const saveEmailTemplate = async () => {
  emailTemplateStore.update.mutateAsync(emailTemplate.value);
};

onMounted(async () => {
  emailTemplateStore.emailTemplateId = emailTemplateId.value;
});
</script>
